import { render, staticRenderFns } from "./SupplyOfServicesPage.vue?vue&type=template&id=508b8310&scoped=true&"
import script from "./SupplyOfServicesPage.vue?vue&type=script&lang=js&"
export * from "./SupplyOfServicesPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplyOfServicesPage.vue?vue&type=style&index=0&id=508b8310&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b8310",
  null
  
)

export default component.exports